var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg404(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 3000 1500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3000,
    height: 1500
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M482.41,600.45H584.76V771.71h61.57v70.54H584.76V905H491V842.25H268.74v-57.5ZM491,676.29,379.65,771.71H491Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1090.78,758.66c0,53-24.47,151.68-204.7,151.68H868.14c-179.41,0-204.69-98.27-204.69-151.68V746.43c0-53.83,25.28-150.06,204.69-150.06h17.94c179.83,0,204.7,96.23,204.7,150.06Zm-99.49-9.38c0-34.25-21.21-79.11-114.18-79.11-94.6,0-114.17,44.86-114.17,79.11v4.89c0,34.25,21.61,82,114.17,82S991.29,789.65,991.29,755Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1320.75,600.45H1423.1V771.71h61.57v70.54H1423.1V905h-93.79V842.25H1107.08v-57.5Zm8.56,75.84L1218,771.71h111.32Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1687,623.22l9.9-17.09,4.32,2.2-7.53,17.93Zm15,0,9.9-17.09,4.31,2.2-7.53,17.93Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1740.21,613.07h-17.59v-6h42.55v6h-17.6v54.48h-7.36Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1765.08,645.81v-.68c0-13.28,9.22-22.59,21.74-22.59s21.74,9.22,21.74,22.5v.68c0,13.37-9.22,22.59-21.83,22.59S1765.08,658.75,1765.08,645.81Zm36.21,0v-.6c0-10.23-5.67-16.83-14.47-16.83s-14.47,6.6-14.47,16.75v.68c0,10.06,5.5,16.66,14.47,16.66S1801.29,655.79,1801.29,645.81Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1842.39,607.06h18.19c11.25,0,19.46,3.72,19.46,15.65v.34c0,5.5-2.2,10.4-9.14,12.77,8.8,2.12,12.1,6.6,12.1,14.47v.34c0,11.42-7.78,16.92-19.88,16.92h-20.73Zm18.19,26.39c8.88,0,12.27-3.21,12.27-10.65v-.34c0-6.85-4-9.65-12.44-9.65h-10.83v20.64Zm2.37,28.34c8.8,0,12.86-3.89,12.86-11.25v-.34c0-7.44-4.15-11-13.88-11h-12.35v22.58Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1891.2,645.89v-.68c0-13.36,8.54-22.67,20.72-22.67,10.24,0,19.88,6.18,19.88,22v2.28h-33.33c.34,10.07,5.16,15.65,14.22,15.65,6.85,0,10.82-2.54,11.76-7.7h7c-1.53,8.89-8.89,13.54-18.87,13.54C1900.08,668.31,1891.2,659.51,1891.2,645.89Zm33.41-4.74c-.67-9.13-5.41-12.77-12.69-12.77s-12,4.91-13.19,12.77Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1939.33,655.28c0-10.24,10.83-13.7,22.16-13.7h6.35v-3.22c0-7-2.71-10-9.48-10-6.09,0-9.47,2.54-10.15,8h-7c.93-10.07,9-13.79,17.51-13.79s16.16,3.47,16.16,15.82v29.19h-7V662c-3.3,4.15-7.28,6.35-13.79,6.35C1945.84,668.31,1939.33,664.33,1939.33,655.28Zm28.51-3.21v-5.5h-6.09c-8.88,0-15.4,2.2-15.4,8.71,0,4.57,2.2,7.44,8.38,7.44C1962.17,662.72,1967.84,658.92,1967.84,652.07Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1988.64,623.3h7v7c2-4.14,6.93-7.78,14.21-7.78,9.13,0,15.56,5,15.56,17.85v27.16h-7V639.88c0-7.78-3.3-11.25-10.4-11.25-6.52,0-12.35,4.15-12.35,12.1v26.82h-7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2035.17,675.58l8.12-18.52,6.85,3.21L2039.74,678Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2082.2,645.81v-.68c0-13.28,9.22-22.59,21.74-22.59s21.74,9.22,21.74,22.5v.68c0,13.37-9.22,22.59-21.82,22.59S2082.2,658.75,2082.2,645.81Zm36.21,0v-.6c0-10.23-5.67-16.83-14.47-16.83s-14.47,6.6-14.47,16.75v.68c0,10.06,5.5,16.66,14.47,16.66S2118.41,655.79,2118.41,645.81Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2136.59,623.3h7v8c2.79-5,6.6-8.46,14.55-8.72v6.6c-8.88.42-14.55,3.21-14.55,14.13v24.28h-7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2190.81,623.3h7v7c2-4.14,6.94-7.78,14.21-7.78,9.14,0,15.57,5,15.57,17.85v27.16h-7V639.88c0-7.78-3.3-11.25-10.41-11.25-6.51,0-12.35,4.15-12.35,12.1v26.82h-7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2238.1,645.81v-.68c0-13.28,9.22-22.59,21.74-22.59s21.74,9.22,21.74,22.5v.68c0,13.37-9.22,22.59-21.83,22.59S2238.1,658.75,2238.1,645.81Zm36.2,0v-.6c0-10.23-5.67-16.83-14.46-16.83s-14.47,6.6-14.47,16.75v.68c0,10.06,5.5,16.66,14.47,16.66S2274.3,655.79,2274.3,645.81Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2294,656.46V629.23h-6.35V623.3H2294V613.24h7V623.3h10.32v5.93H2301v26.56c0,4.31,1.95,6.43,5.5,6.43a14.46,14.46,0,0,0,5.41-.93v5.92a16.68,16.68,0,0,1-6,.93C2297.9,668.14,2294,663.4,2294,656.46Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2346.45,656.46V629.23h-6.34V623.3h6.34V613.24h7V623.3h10.32v5.93h-10.32v26.56c0,4.31,2,6.43,5.5,6.43a14.56,14.56,0,0,0,5.42-.93v5.92a16.7,16.7,0,0,1-6,.93C2350.34,668.14,2346.45,663.4,2346.45,656.46Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2371.66,645.81v-.68c0-13.28,9.22-22.59,21.74-22.59s21.74,9.22,21.74,22.5v.68c0,13.37-9.22,22.59-21.82,22.59S2371.66,658.75,2371.66,645.81Zm36.21,0v-.6c0-10.23-5.67-16.83-14.47-16.83s-14.46,6.6-14.46,16.75v.68c0,10.06,5.49,16.66,14.46,16.66S2407.87,655.79,2407.87,645.81Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2449,607.06h18.19c11.25,0,19.46,3.72,19.46,15.65v.34c0,5.5-2.2,10.4-9.14,12.77,8.8,2.12,12.1,6.6,12.1,14.47v.34c0,11.42-7.78,16.92-19.88,16.92H2449Zm18.19,26.39c8.88,0,12.27-3.21,12.27-10.65v-.34c0-6.85-4-9.65-12.44-9.65h-10.83v20.64Zm2.37,28.34c8.8,0,12.86-3.89,12.86-11.25v-.34c0-7.44-4.15-11-13.87-11h-12.36v22.58Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2497.78,645.89v-.68c0-13.36,8.55-22.67,20.73-22.67,10.23,0,19.88,6.18,19.88,22v2.28h-33.33c.33,10.07,5.16,15.65,14.21,15.65,6.85,0,10.83-2.54,11.76-7.7h7c-1.52,8.89-8.88,13.54-18.87,13.54C2506.66,668.31,2497.78,659.51,2497.78,645.89Zm33.42-4.74c-.68-9.13-5.42-12.77-12.69-12.77s-12,4.91-13.2,12.77Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2545.91,655.28c0-10.24,10.83-13.7,22.17-13.7h6.34v-3.22c0-7-2.71-10-9.47-10-6.1,0-9.48,2.54-10.16,8h-7c.93-10.07,9-13.79,17.51-13.79s16.16,3.47,16.16,15.82v29.19h-7V662c-3.3,4.15-7.28,6.35-13.79,6.35C2552.43,668.31,2545.91,664.33,2545.91,655.28Zm28.51-3.21v-5.5h-6.09c-8.88,0-15.4,2.2-15.4,8.71,0,4.57,2.2,7.44,8.38,7.44C2568.75,662.72,2574.42,658.92,2574.42,652.07Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2595.23,623.3h7v7c2-4.14,6.94-7.78,14.21-7.78,9.14,0,15.57,5,15.57,17.85v27.16h-7V639.88c0-7.78-3.29-11.25-10.4-11.25-6.51,0-12.35,4.15-12.35,12.1v26.82h-7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1740,714.57h-17.59v-6H1765v6h-17.6v54.48H1740Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1774.55,703.66h7v28.17c2-4.14,6.94-7.78,14.22-7.78,9.13,0,15.56,5,15.56,17.85v27.15h-7V741.39c0-7.78-3.3-11.25-10.4-11.25-6.52,0-12.36,4.15-12.36,12.1v26.81h-7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1821.5,756.79c0-10.24,10.83-13.71,22.16-13.71H1850v-3.21c0-7-2.71-10-9.48-10-6.09,0-9.47,2.53-10.15,8h-7c.93-10.07,9-13.79,17.51-13.79s16.16,3.47,16.16,15.82v29.18h-7v-5.58c-3.3,4.15-7.28,6.35-13.79,6.35C1828,769.82,1821.5,765.84,1821.5,756.79Zm28.51-3.22v-5.5h-6.09c-8.88,0-15.4,2.2-15.4,8.72,0,4.57,2.2,7.44,8.38,7.44C1844.34,764.23,1850,760.42,1850,753.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1872.34,758V730.73H1866v-5.92h6.35V714.74h7v10.07h10.32v5.92h-10.32v26.56c0,4.32,1.94,6.43,5.5,6.43a14.26,14.26,0,0,0,5.41-.93v5.92a16.64,16.64,0,0,1-6,.94C1876.23,769.65,1872.34,764.91,1872.34,758Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1922.16,710.94a4.65,4.65,0,1,1,4.65,4.65A4.7,4.7,0,0,1,1922.16,710.94Zm1.27,13.87h7v44.24h-7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1941.19,755.43H1948c.51,5.25,3.3,8.55,10.41,8.55,6.68,0,9.64-2.29,9.64-7s-3.47-6.18-10.32-7.45c-11.5-2.11-15.39-5.33-15.39-13,0-8.2,8-12.43,15-12.43,8,0,14.8,3.21,16,12.77h-6.77c-1-4.82-3.72-6.93-9.31-6.93-5.07,0-8.37,2.53-8.37,6.34,0,4,2.2,5.58,10.32,7,9.14,1.69,15.57,3.72,15.57,13.11,0,8-5.5,13.46-16.25,13.46C1948,769.82,1941.61,764.49,1941.19,755.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2009.37,758V730.73H2003v-5.92h6.34V714.74h7v10.07h10.32v5.92h-10.32v26.56c0,4.32,1.95,6.43,5.5,6.43a14.26,14.26,0,0,0,5.41-.93v5.92a16.6,16.6,0,0,1-6,.94C2013.26,769.65,2009.37,764.91,2009.37,758Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2037.88,703.66h7v28.17c2-4.14,6.93-7.78,14.21-7.78,9.14,0,15.56,5,15.56,17.85v27.15h-7V741.39c0-7.78-3.3-11.25-10.4-11.25-6.52,0-12.35,4.15-12.35,12.1v26.81h-7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2085.16,747.4v-.68c0-13.37,8.55-22.67,20.73-22.67,10.23,0,19.88,6.17,19.88,22v2.29h-33.33c.33,10.06,5.16,15.65,14.21,15.65,6.85,0,10.83-2.54,11.76-7.7h7c-1.52,8.88-8.88,13.54-18.87,13.54C2094,769.82,2085.16,761,2085.16,747.4Zm33.42-4.74c-.68-9.14-5.42-12.77-12.69-12.77s-12,4.9-13.2,12.77Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2190.73,761.44a18.66,18.66,0,0,1-15.14,8.38c-11.59,0-20-8.21-20-22v-.68c0-13.53,8.46-23.09,20.64-23.09,7.36,0,11.93,3.55,14.47,7.87v-7.11h7v59.64h-7Zm.25-14.21v-.68c0-11.33-5.41-16.66-14-16.66-8.8,0-14,6.17-14,16.92v.67c0,11.17,6,16.5,13.45,16.5C2184.55,764,2191,758.56,2191,747.23Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2211.54,752.81v-28h7v27.66c0,7.79,3.3,11.25,10.23,11.25,6.26,0,12.19-4.14,12.19-12.09V724.81h7v44.24h-7v-7c-2,4.15-6.94,7.79-14.05,7.79C2218.13,769.82,2211.54,765,2211.54,752.81Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2258.91,747.4v-.68c0-13.37,8.54-22.67,20.72-22.67,10.24,0,19.88,6.17,19.88,22v2.29h-33.33c.34,10.06,5.16,15.65,14.21,15.65,6.86,0,10.83-2.54,11.76-7.7h7c-1.52,8.88-8.88,13.54-18.86,13.54C2267.79,769.82,2258.91,761,2258.91,747.4Zm33.41-4.74c-.68-9.14-5.41-12.77-12.69-12.77s-12,4.9-13.19,12.77Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2307,755.43h6.85c.51,5.25,3.3,8.55,10.4,8.55,6.69,0,9.65-2.29,9.65-7s-3.47-6.18-10.32-7.45c-11.51-2.11-15.4-5.33-15.4-13,0-8.2,8-12.43,15-12.43,8,0,14.81,3.21,16,12.77h-6.76c-1-4.82-3.73-6.93-9.31-6.93-5.08,0-8.38,2.53-8.38,6.34,0,4,2.2,5.58,10.33,7,9.13,1.69,15.56,3.72,15.56,13.11,0,8-5.5,13.46-16.24,13.46C2313.8,769.82,2307.46,764.49,2307,755.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2352.8,758V730.73h-6.35v-5.92h6.35V714.74h7v10.07h10.32v5.92h-10.32v26.56c0,4.32,1.95,6.43,5.5,6.43a14.26,14.26,0,0,0,5.41-.93v5.92a16.64,16.64,0,0,1-6,.94C2356.69,769.65,2352.8,764.91,2352.8,758Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2380.21,710.94a4.65,4.65,0,1,1,4.65,4.65A4.7,4.7,0,0,1,2380.21,710.94Zm1.26,13.87h7v44.24h-7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2399.58,747.31v-.67c0-13.29,9.22-22.59,21.74-22.59s21.74,9.22,21.74,22.5v.68c0,13.36-9.22,22.59-21.83,22.59S2399.58,760.26,2399.58,747.31Zm36.2,0v-.59c0-10.24-5.67-16.83-14.46-16.83s-14.47,6.59-14.47,16.75v.67c0,10.07,5.5,16.67,14.47,16.67S2435.78,757.29,2435.78,747.31Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2454,724.81h7v7c2-4.14,6.93-7.78,14.21-7.78,9.13,0,15.56,5,15.56,17.85v27.15h-7V741.39c0-7.78-3.3-11.25-10.4-11.25-6.52,0-12.35,4.15-12.35,12.1v26.81h-7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2504,764.06a5.42,5.42,0,1,1,5.41,5.42A5.39,5.39,0,0,1,2504,764.06Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2525.27,725.57l7.53-17.93,6.69,3-9.9,17.09Zm15,0,7.53-17.93,6.68,3-9.9,17.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1687.34,894.71c.59-7.36,4.74-10.83,9-10.83,5.58,0,9,4.32,11.84,4.32,1.78,0,3.56-1.44,3.81-4.49h5.58c-.5,7.53-4.73,10.83-8.71,10.83-5.84,0-9.31-4.31-12-4.31-1.86,0-3.47,1.52-3.89,4.48Z",
    style: {
      fill: "#a270ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1746.55,853.09h7.53l12.27,48.81,14.21-48.81h5.25l14.21,49,12.43-49h6.86l-15.74,60.49h-6.77l-13.7-47.8L1769,913.58h-6.68Z",
    style: {
      fill: "#a270ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1827.34,855.46a4.65,4.65,0,1,1,4.65,4.65A4.69,4.69,0,0,1,1827.34,855.46Zm1.27,13.87h7v44.25h-7Z",
    style: {
      fill: "#a270ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1850.18,848.19h7.1v65.39h-7.1Z",
    style: {
      fill: "#a270ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1871.83,848.19h7.11v65.39h-7.11Z",
    style: {
      fill: "#a270ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1892.21,855.46a4.66,4.66,0,1,1,4.66,4.65A4.7,4.7,0,0,1,1892.21,855.46Zm1.27,13.87h7v44.25h-7Z",
    style: {
      fill: "#a270ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1911.25,901.31c0-10.23,10.83-13.7,22.16-13.7h6.35v-3.22c0-7-2.71-10-9.48-10-6.09,0-9.47,2.54-10.15,8h-7c.93-10.07,9-13.79,17.51-13.79s16.16,3.47,16.16,15.82v29.19h-7V908c-3.3,4.15-7.28,6.35-13.79,6.35C1917.76,914.34,1911.25,910.36,1911.25,901.31Zm28.51-3.21v-5.5h-6.09c-8.89,0-15.4,2.2-15.4,8.71,0,4.57,2.2,7.44,8.37,7.44C1934.09,908.75,1939.76,905,1939.76,898.1Z",
    style: {
      fill: "#a270ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1960.56,869.33h7v6.77c2-4.14,6.86-7.53,13.2-7.53,5.67,0,10.66,2.37,12.94,8.29,3-5.75,9.65-8.29,15.15-8.29,8,0,14.88,4.74,14.88,17.6v27.41h-7V885.66c0-7.78-3.3-11-9.39-11-5.75,0-11.67,3.89-11.67,11.85v27.07h-7V885.66c0-7.78-3.3-11-9.39-11-5.76,0-11.68,3.89-11.68,11.85v27.07h-7Z",
    style: {
      fill: "#a270ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2060.46,853.09h18.19c11.25,0,19.46,3.72,19.46,15.65v.34c0,5.5-2.2,10.41-9.14,12.77,8.8,2.12,12.1,6.6,12.1,14.47v.34c0,11.42-7.79,16.92-19.88,16.92h-20.73Zm18.19,26.4c8.88,0,12.27-3.22,12.27-10.66v-.34c0-6.85-4-9.65-12.44-9.65h-10.83v20.65Zm2.37,28.33c8.8,0,12.86-3.89,12.86-11.25v-.33c0-7.45-4.15-11-13.88-11h-12.35v22.58Z",
    style: {
      fill: "#a270ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2109.27,891.92v-.68c0-13.36,8.54-22.67,20.72-22.67,10.24,0,19.88,6.18,19.88,22v2.28h-33.33c.34,10.07,5.16,15.65,14.22,15.65,6.85,0,10.82-2.54,11.75-7.7h7c-1.53,8.89-8.89,13.54-18.87,13.54C2118.15,914.34,2109.27,905.54,2109.27,891.92Zm33.41-4.74c-.67-9.13-5.41-12.77-12.69-12.77s-12,4.91-13.19,12.77Z",
    style: {
      fill: "#a270ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2157.4,901.31c0-10.23,10.83-13.7,22.16-13.7h6.35v-3.22c0-7-2.71-10-9.48-10-6.09,0-9.47,2.54-10.15,8h-7c.93-10.07,9-13.79,17.51-13.79s16.16,3.47,16.16,15.82v29.19h-7V908c-3.3,4.15-7.28,6.35-13.79,6.35C2163.91,914.34,2157.4,910.36,2157.4,901.31Zm28.51-3.21v-5.5h-6.09c-8.89,0-15.4,2.2-15.4,8.71,0,4.57,2.2,7.44,8.37,7.44C2180.24,908.75,2185.91,905,2185.91,898.1Z",
    style: {
      fill: "#a270ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2206.71,869.33h7v7c2-4.15,6.93-7.79,14.21-7.79,9.13,0,15.56,5,15.56,17.85v27.16h-7V885.92c0-7.79-3.3-11.26-10.4-11.26-6.52,0-12.35,4.15-12.35,12.1v26.82h-7Z",
    style: {
      fill: "#a270ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2253.66,900h6.85c.51,5.24,3.3,8.54,10.41,8.54,6.68,0,9.64-2.28,9.64-7s-3.47-6.18-10.32-7.44c-11.5-2.12-15.4-5.33-15.4-13,0-8.21,8-12.44,15-12.44,7.95,0,14.8,3.22,16,12.78H2279c-1-4.83-3.72-6.94-9.31-6.94-5.07,0-8.37,2.54-8.37,6.34,0,4,2.2,5.59,10.32,7,9.13,1.69,15.56,3.72,15.56,13.11,0,8-5.49,13.45-16.24,13.45C2260.43,914.34,2254.08,909,2253.66,900Z",
    style: {
      fill: "#a270ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2297.9,869.33h7v7.45c2.54-4.32,8.54-8.21,15-8.21,11.59,0,20.14,8.46,20.14,22.25v.68c0,13.53-8,22.84-20.14,22.84-7.27,0-12.43-3.64-15-8V929h-7Zm34.85,22.51v-.68c0-11.17-6.17-16.75-13.62-16.75-8.2,0-14.46,5.41-14.46,16.75v.68c0,11.33,5.92,16.66,14.55,16.66C2328,908.5,2332.75,902.58,2332.75,891.84Z",
    style: {
      fill: "#a270ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2347.64,891.92v-.68c0-13.36,8.54-22.67,20.72-22.67,10.24,0,19.88,6.18,19.88,22v2.28h-33.33c.34,10.07,5.16,15.65,14.22,15.65,6.85,0,10.82-2.54,11.75-7.7h7c-1.53,8.89-8.89,13.54-18.87,13.54C2356.52,914.34,2347.64,905.54,2347.64,891.92Zm33.41-4.74c-.67-9.13-5.41-12.77-12.69-12.77s-12,4.91-13.19,12.77Z",
    style: {
      fill: "#a270ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2395.77,901.31c0-10.23,10.83-13.7,22.16-13.7h6.35v-3.22c0-7-2.71-10-9.48-10-6.09,0-9.47,2.54-10.15,8h-7c.93-10.07,9-13.79,17.51-13.79s16.16,3.47,16.16,15.82v29.19h-7V908c-3.3,4.15-7.28,6.35-13.79,6.35C2402.28,914.34,2395.77,910.36,2395.77,901.31Zm28.51-3.21v-5.5h-6.09c-8.89,0-15.4,2.2-15.4,8.71,0,4.57,2.2,7.44,8.37,7.44C2418.61,908.75,2424.28,905,2424.28,898.1Z",
    style: {
      fill: "#a270ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2445.08,869.33h7v8c2.8-5,6.6-8.46,14.56-8.72v6.6c-8.89.42-14.56,3.22-14.56,14.13v24.28h-7Z",
    style: {
      fill: "#a270ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2472.32,891.92v-.68c0-13.36,8.54-22.67,20.73-22.67,10.23,0,19.88,6.18,19.88,22v2.28H2479.6c.33,10.07,5.16,15.65,14.21,15.65,6.85,0,10.83-2.54,11.76-7.7h7c-1.53,8.89-8.88,13.54-18.87,13.54C2481.2,914.34,2472.32,905.54,2472.32,891.92Zm33.42-4.74c-.68-9.13-5.42-12.77-12.69-12.77s-12,4.91-13.2,12.77Z",
    style: {
      fill: "#a270ff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Bean-Blueprint"
  }, /*#__PURE__*/React.createElement("g", {
    id: "BadVibe"
  }, /*#__PURE__*/React.createElement("g", {
    id: "GA-02-Solid"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M780.17,837.67a89.18,89.18,0,1,1,89.18-89.18A89.18,89.18,0,0,1,780.17,837.67Zm284.11-89.18a89.18,89.18,0,1,0-89.18,89.18A89.18,89.18,0,0,0,1064.28,748.49Z",
    style: {
      fill: "#a270ff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Eyes"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M774,783.57l-7.24-2.81c-39.56-16.38-65.66-44.12-58.27-61.94,6.89-16.65,40.58-18.76,77.25-5.6ZM986.6,708.11a165.16,165.16,0,0,0-24.86,8.11c-39.57,16.38-65.66,44.11-58.28,61.94,6.5,15.69,36.79,18.47,70.95,7.72Z",
    style: {
      fill: "#fff"
    }
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Pupils"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1046.74,718.82c7.38,17.82-18.71,45.56-58.27,61.94-4.73,2-9.43,3.66-14.06,5.12a54.34,54.34,0,0,1,12.19-77.77C1016.16,701.09,1040.94,704.8,1046.74,718.82Zm-253.21-2.6c-2.59-1.08-5.18-2.07-7.75-3A54.33,54.33,0,0,0,774,783.57c36.87,13.37,70.84,11.32,77.77-5.41C859.19,760.33,833.1,732.6,793.53,716.22Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Brows"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M838.85,716.62H823.78a5.87,5.87,0,0,1-5.85-5.86h0a5.87,5.87,0,0,1,5.85-5.86h15.07a5.87,5.87,0,0,1,5.86,5.86h0A5.88,5.88,0,0,1,838.85,716.62Zm98.49-5.86h0a5.87,5.87,0,0,0-5.86-5.86H916.42a5.87,5.87,0,0,0-5.86,5.86h0a5.87,5.87,0,0,0,5.86,5.86h15.06A5.87,5.87,0,0,0,937.34,710.76Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.cb531ef6a922fc0cff0433c888283e9c.svg";
export { ForwardRef as ReactComponent };